// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatsAppButton_root__3oT9_"};